module.exports = __webpack_public_path__ + "static/img/action-account-verification.8622284.svg";